__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-25-1774421641-stable-dev/";